import React from 'react';
import PropTypes from 'prop-types';
import styled from 'fe-styled-components';
import theme from 'fe-appdir-lib-theme';
import { AppReview } from './AppReview';
import { IconInfoSlot } from './IconInfoSlot';
import { CurrencyDollar, StatusResolve, Tag, User } from 'fe-comp-svg-icon';

const PROP_TYPES = {
  rating: PropTypes.number,
  reviewCount: PropTypes.number,
  reviewLink: PropTypes.string,
  isExternalInstall: PropTypes.bool.isRequired,
  price: PropTypes.string,
  planTypes: PropTypes.string,
  requirements: PropTypes.string,
  categories: PropTypes.arrayOf(PropTypes.string),
};

const DEFAULT_PROPS = {
  rating: null,
  reviewCount: null,
  reviewLink: null,
  price: null,
  planTypes: null,
  requirements: null,
  categories: null,
};

const Container = styled.div`
  font-family: ${theme.fontFamilyPrimary};
  background-color: ${theme.colorWhite};
  padding: ${theme.spacingXl};
  padding-right: calc(${theme.spacingXl} + ${theme.spacingSm});
  box-shadow: 0 5px 18px 3px rgba(0, 0, 0, 0.1);
  font-size: ${theme.fontSizeSm};

  & > :last-child {
    margin-bottom: 0;
  }

  @media (max-width: ${theme.breakpointMd}) {
    margin: ${theme.spacingMd} 0;
  }

  @media (min-width: ${theme.breakpointMd}) {
    flex-basis: calc(1 / 3 * 100%);
    margin-left: ${theme.spacingMd};
  }
`;

const H3 = styled.h3`
  margin-top: 0;
  line-height: 0.9;
  font-weight: ${theme.fontWeightSemibold};
  font-size: ${theme.fontSizeLg};
`;

const AppInfo = ({
  rating,
  reviewCount,
  isExternalInstall,
  price,
  planTypes,
  requirements,
  categories,
  reviewLink,
}) => (
  <Container>
    <H3>App Info</H3>
    {rating && reviewCount && reviewLink ? (
      <AppReview
        rating={rating}
        reviewCount={reviewCount}
        reviewLink={reviewLink}
      />
    ) : null}
    {price ? (
      <IconInfoSlot glyph={CurrencyDollar} title="Price:">
        {price === '$0'
          ? isExternalInstall
            ? 'CONTACT VENDOR FOR PRICING'
            : 'FREE'
          : price}
        <br />
        {isExternalInstall || price === '$0'
          ? null
          : '(FREE for all Enterprise)'}
      </IconInfoSlot>
    ) : null}
    {planTypes ? (
      <IconInfoSlot glyph={User} title="Available For:">
        {planTypes}
      </IconInfoSlot>
    ) : null}
    <IconInfoSlot glyph={StatusResolve} title="Requirements:">
      {requirements ? requirements : 'None'}
    </IconInfoSlot>
    {categories && categories.length > 0 ? (
      <IconInfoSlot glyph={Tag} title="Category:">
        {categories.join(', ')}
      </IconInfoSlot>
    ) : null}
  </Container>
);

AppInfo.propTypes = PROP_TYPES;
AppInfo.defaultProps = DEFAULT_PROPS;
AppInfo.displayName = 'AppInfo';

export { AppInfo };
